import React, { useState } from 'react';
import { GroupsForm } from './GroupsForm';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Create_Group } from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Validation from '../../../../../../../components/Validation';
function CreateGroupsForm({ propertyId, serviceProviders, userName, service }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [visible, setVisible] = useState(false);
    const handleSubmit = (data) => {
        console.log('groupdata', data)
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Create_Group}`,
            data,
        })
            .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            })
            .catch((err) => {
                console.log('err', err);
            });
    };

    return (
        <div>
            <Button
                color="primary"
                outline
                size="xs"
                className="ml-2"
                onClick={() => {
                    setVisible(!visible);
                }}
            // style={{ width: '100%', borderRadius: '6px' }}
            >
                + Create a New Group
            </Button>
            <GroupsForm
                formLabel="Create a New Group"
                visible={visible}
                toggle={() => {
                    setVisible(!visible);
                }}
                submit={handleSubmit}
                serviceProviders={serviceProviders}
                userName={userName}
                service={service}
            />
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </div>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, userName } = settings;
    return {
        propertyId, userName
    };
};

export default injectIntl(connect(mapStateToProps, {})(CreateGroupsForm));
